<template>
  <ul class="nav navbar-nav" v-if="showBanner">
    <li>
      <div class="license-banner label">
        <template v-if="isTrial && daysLeftInLicense > 0">
          <p>
            <span class="countdown"
            >{{ daysLeftInLicense }} <small class="days-left">days<br >remaining</small></span
            >
          </p>
        </template>
        <template v-if="isIndividual && isPremium && isLicenseExpired">
          <p class="license-ended">Subscription ended</p>
        </template>
        <template v-if="isEnterpriseEndingSoon">
          <p>
            <span class="countdown"
            >{{ daysLeftInLicense }} <small class="days-left">days<br >remaining</small></span
            >
          </p>
          <p>
            {{
              isMultiyear
                ? "Your license will be updated when your organization's multiyear renewal process is complete"
                : 'Please contact your administrator to renew your district membership'
            }}
          </p>
        </template>
        <template v-if="(isTrial && !universityPartnership) || (isIndividual && isPremium)">
          <a :href="subscribe">View Plans</a>
        </template>
        <template v-if="isTrial && universityPartnership">
          <a :href="subscribeUniversity">University Membership</a>
        </template>
        <br >
        <a class="share" :href="share">Share Toolkit</a>
      </div>
    </li>
  </ul>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import { toolkitUrls } from '@/links'

export default {
  name: 'LicenseBanner',
  data() {
    return { ...toolkitUrls }
  },
  computed: {
    ...mapGetters('user', [
      'isSuperAdmin',
      'isTrial',
      'isPremium',
      'isEnterprise',
      'isIndividual',
      'isMultiyear',
      'daysLeftInLicense',
      'isLicenseExpired',
      'isEnterpriseEndingSoon',
    ]),
    ...mapState('user', {
      universityPartnership: (state) => state.domain_upp,
    }),
    showBanner() {
      return (
        !this.isSuperAdmin &&
        (!this.isEnterprise ||
          !this.isPremium ||
          this.isEnterpriseEndingSoon ||
          this.isLicenseExpired)
      )
    },
  },
}
</script>

<style scoped lang="less">
@import '~@/variables.less';
.navbar-nav {
  max-height: 50px;
  overflow: visible;
}
@media screen and (max-width: @screen-md-max) {
  .navbar-nav {
    max-height: none;
  }
}

.label.license-banner {
  color: @gray-dark;
  display: block;
  padding: 0.25rem 1rem;
  padding-top: 0;
  margin-left: 10px;
  font-size: 12px;
  font-weight: normal;
  text-align: center;
  border-radius: 0px 0px 5px 5px;
  background: @gb_orange;
  white-space: normal;
  width: fit-content;
  max-width: 175px;
  .countdown {
    padding-top: 8px;
    padding-bottom: 8px;
    font-size: 36px;
    font-weight: 300;
    display: block;
    line-height: 19px;
    small.days-left {
      font-size: 12px;
      font-weight: normal;
      line-height: 16px;
      text-align: left;
      display: inline-block;
    }
  }
  .license-ended {
    font-size: 16px;
  }
  p {
    margin-bottom: 0;
    line-height: 16px;
  }
  a:link,
  a:visited,
  a:active {
    color: @gray-dark;
    font-weight: normal;
    i {
      font-size: 16px;
    }
  }
  a {
    line-height: 1.5;
  }
}
</style>
